// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
export function getCircularReferenceReplacer() {
    const values: Array<any> = [];
    // https://www.typescriptlang.org/docs/handbook/2/functions.html#declaring-this-in-a-function
    return function (this: any, key: string, value: any) {
        if (value === null || typeof value !== 'object') {
            return value;
        }

        // while is important, because values can have multiple elements that are not 'this'
        // eslint-disable-next-line no-invalid-this
        while (values.length > 0 && values[values.length - 1] !== this) {
            // prevent false positives, if the object have same values with circular references
            values.pop();
        }

        // recursion
        // if replacer returns undefined => remove property in JSON
        if (values.includes(value)) {
            return undefined;
        }

        values.push(value);
        return value;
    };
}
